import { Lock, Mail, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const TOKENIZER_CSS = encodeURIComponent(
  "body{margin:0;padding:2px;font-family:Arial,Helvetica,sans-serif;}label{font-size:12px;color:#334155;font-weight:600;display:block;margin:10px 0 4px;}input{border:1px solid #e2e8f0;border-radius:8px;padding:10px 12px;font-size:14px;color:#0f172a;width:240px;box-sizing:border-box;}input:focus{outline:none;border-color:#2563eb;}select{border:1px solid #e2e8f0;border-radius:8px;padding:9px 8px;font-size:14px;color:#0f172a;background:#fff;margin-right:6px;}"
);
const TOKENIZER_PARAMS = `useexpiry=true&usecvv=true&cardnumbernumericonly=true&formatinput=true&invalidinputevent=true&tokenizewheninactive=true&css=${TOKENIZER_CSS}`;

export default function PaymentSection({ paymentCfg, card, setCard, cardToken, tokenizerError, cardError }) {
  return (
    <div className="border border-slate-200 rounded-2xl p-6 space-y-4" data-testid="payment-card-section">
      {paymentCfg?.enabled ? (
        <>
          <div>
            <Label>Cardholder Name</Label>
            <Input name="cardName" value={card.cardName} onChange={(e) => setCard({ ...card, cardName: e.target.value })} placeholder="Name on card" data-testid="payment-card-name" />
          </div>
          <div>
            <Label>Card Details</Label>
            <iframe
              title="Secure card details"
              src={`${paymentCfg.tokenizer_url}?${TOKENIZER_PARAMS}`}
              className="w-full h-60 border border-slate-100 rounded-xl bg-slate-50/50 mt-1"
              referrerPolicy="strict-origin-when-cross-origin"
              data-testid="payment-tokenizer-iframe"
            />
          </div>
          {cardToken && (
            <p className="text-xs text-emerald-600 flex items-center gap-1.5" data-testid="payment-token-ready">
              <ShieldCheck className="h-3.5 w-3.5 shrink-0" /> Card details securely captured
            </p>
          )}
          {tokenizerError && <p className="text-xs text-red-500" data-testid="payment-tokenizer-error">{tokenizerError}</p>}
          {cardError && <p className="text-xs text-red-500" data-testid="payment-card-error">{cardError}</p>}
          <p className="text-xs text-slate-400 leading-relaxed flex items-center gap-1.5">
            <Lock className="h-3.5 w-3.5 text-brandblue-600 shrink-0" />
            Payments are processed securely by CardPointe. Your card details never touch our servers.
          </p>
        </>
      ) : (
        <div className="flex items-start gap-3" data-testid="payment-instructions-notice">
          <Mail className="h-5 w-5 text-brandblue-600 mt-0.5 shrink-0" />
          <div>
            <p className="text-sm font-semibold text-slate-900">No card details needed</p>
            <p className="text-xs text-slate-500 leading-relaxed mt-1.5">
              Place your order and you'll receive a verification email with next steps.
            </p>
          </div>
        </div>
      )}
      <div className="pt-4 border-t border-slate-100 text-xs text-slate-500 leading-relaxed" data-testid="payment-net-terms-note">
        <span className="font-semibold text-slate-700">Institutional buyer?</span> We accept purchase orders and can arrange invoicing / net terms for laboratories, universities, and research organizations.{" "}
        <Link to="/contact" className="text-brandblue-600 font-semibold hover:text-brandblue-800 transition-colors" data-testid="payment-net-terms-link">Contact us</Link> to set it up.
      </div>
    </div>
  );
}
